export const MAX_ITEMS_PER_ROW = 3;
export const MAX_ROW_COUNT = 3;
